export const VERTICAL_BAR_TICKS_WIDTH = 120
